// extracted by mini-css-extract-plugin
module.exports = {"navFooterContent":"footer-module--navFooterContent--1RCHO","bottomContainer":"footer-module--bottomContainer--2ADKE","linkStyles":"footer-module--linkStyles--3lG8-"};